import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { H2 } from "components/ui/Typography";
import PersonaliseCard from "components/PersonaliseCard/PersonaliseCard";
import { Button, NavigationFooter } from "./styles";
import { Link, Navigate } from "react-router-dom";
import { useCustomiseReportScreen } from "./hooks";
import ReportSectionsCard from "components/ReportSectionsCard/ReportSections";
import FileIcon from "components/icons/FileIcon";

function CustomiseReport() {
  const { redirectHome } = useCustomiseReportScreen();
  if (redirectHome) {
    return <Navigate to="/" />;
  }

  return (
    <Container>
      <Row>
        <Col>
          <H2>Customise your report</H2>
        </Col>
      </Row>

      <ReportSectionsCard />

      <PersonaliseCard />

      <NavigationFooter>
        <Link to="/reportingperiod">
          <Button secondary>Back</Button>
        </Link>
        <Button disabled={true}>
          View report <FileIcon />
        </Button>
      </NavigationFooter>
    </Container>
  );
}

export default CustomiseReport;
